import {
  getDay,
  isBefore, isSameDay, set
} from "date-fns";
import moment from "moment";
import React from "react";
import { DateObject } from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { dateInArray, durationToMinutes, minutesToDuration } from "../../../../helpers";
import { useLocalStorage } from "../../../../hooks";

import SuccessScheduleModal from "./SuccessScheduleModal";

import * as dashboardActions from "../../../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../../../redux/reducers/dashboardReducer";

import { useToast } from "../../../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../../utils/axiosInstance";
import { getUrlForEvent } from "../../../../utils/confighelpers";
import AddScheduleStep1 from "./AddScheduleStep1";
import EditSchedules from "./EditSchedules";
import { useTranslation } from "react-i18next";

export default function ScheduleTab({
  edit = false,
  duration,
  classObj,
  eventFormValues,
  setEventFormValues,
  formEventErrors,
  formScheduleValues,
  handleFormValueChange,
  setFormScheduleValues,
  setTabCurrentState,
  defaultDataSaveProgress,
  dataSaveProgress,
  setDataSaveProgress,
  defaultScheduleData,
  setDefaultScheduleData,
  reloadScheduleDetails = () => null,
  isFromDetail = false
}) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userToken] = useLocalStorage("userToken");
  const [newDraftEventData, setNewDraftEventData] = useLocalStorage("newDraftEventData");
  const dashboardReduxState = useSelector(dashboardState);
  const loadingReduxState = useSelector(loadingState);
  const [displayDuration, setDisplayDuration] = React.useState("");
  const [activeStep, setActiveStep] = React.useState(0);
  const currentTime = moment().add(1, "days")
  const draftData = newDraftEventData && Object.keys(newDraftEventData).length > 0 ? newDraftEventData.eventScheduleData : {};
  const [formValues, setFormValues] = React.useState({
    radioValue: "One Time",
    radioValue2: "",
    // startDate: !edit && draftData?.startDate ? moment(draftData?.startDate).toDate() : currentTime.toDate(),
    // startTime: !edit && draftData?.startTime ? moment(draftData?.startTime).toDate() : currentTime.add(1, "minutes").toDate(),
    startDate: formScheduleValues?.startDate ? moment(formScheduleValues?.startDate).toDate() : currentTime.toDate(),
    startTime: formScheduleValues?.startTime ? moment(formScheduleValues?.startTime).toDate() : currentTime.add(1, "minutes").toDate(),
    endDate: formScheduleValues?.endDate ? moment(formScheduleValues?.endDate).toDate() : currentTime.toDate(),
    // endTime: moment(),
    endDateTime: formScheduleValues?.startDate ? moment(formScheduleValues?.startDate).add(durationToMinutes(duration), "minutes").toDate() : currentTime.add(15, "minutes").toDate(),
    // endTime: !edit && draftData?.endTime ? moment(draftData?.endTime).toDate() : currentTime.add(durationToMinutes(duration), "minutes").toDate(),
    endTime: formScheduleValues?.startDate ? moment(formScheduleValues?.startDate).add(durationToMinutes(duration), "minutes").toDate()  : currentTime.add(durationToMinutes(duration), "minutes").toDate(),
    location: formScheduleValues.location ? formScheduleValues.location : {},
    daysInWeek: [],
  });
  const [formErrors, setFormErrors] = React.useState({});
  const [isSubmitting, setSubmitting] = React.useState(false);
  const [formResData, setFormResData] = React.useState({});
  const [openSuccessModal, setOpenSuccessModal] = React.useState(false);
  const [shareLink, setShareLink] = React.useState("");  

  React.useEffect(() => {
    setFormErrors(formEventErrors);
  }, [formEventErrors]);

  React.useEffect(() => {
    
    if (Object.keys(defaultScheduleData).length === 0) {
      setDefaultScheduleData(formValues);
    } else {
      setFormValues(defaultScheduleData);
    }
  }, []);


  React.useEffect(() => {
    setDefaultScheduleData(formValues);

    let time = durationToMinutes(duration);
    const { mins, hours } = minutesToDuration(time);
    const minutes = (mins) ? mins : 0;
    setDisplayDuration(`${time} = ${moment((formValues.startTime) ? (typeof formValues.startTime == "object" ? formValues.startTime : formValues.startTime.toDate()) : moment()).add({
      hour: hours,
      minute: minutes,
      seconds: 0,
    }).format("HH:mm")} (${hours} hr ${minutes} mins)`);
    setFormScheduleValues(formValues)
    // handleNextStep();
  }, [formValues]);

  const publishScheduledDetails = async (body, isPublished = true) => {
    body.eventId = classObj.eventId;
    const config = {
      method: "post",
      // url: `${getUrlForEvent()}schools/scheduleTheClass`,
      url: `${getUrlForEvent()}schedule/create`,
      data: body,
    };
    dispatch(setActionLoading(true));
    const request = await axiosInstance(config);
    dispatch(setActionLoading(false));
    setSubmitting(false);
    if (request.data.statusCode !== 200) {
      addErrorToast(request.data.message);
      return false;
    } else {
      if (isPublished) {
        body.isPublished = true;
        return await publishScheduledDetails(body, false);
      }
      addSuccessToast(t("successes.success"));
      return true;
    }
  }

  const handleNextStep = () => {
    setSubmitting(true);
    const errors = {};
    if (formValues.radioValue2 !== "Custom" && !formValues.startDate) {
      errors.startDate = t("errors.required");
    }
    if (formValues.radioValue !== "One Time") {
      if (formValues.radioValue2 !== "Custom") {
        if (!formValues.endDate) {
          errors.endDate = t("errors.required");
        }
      }
    }
    if (formValues.radioValue !== "One Time" && formValues.radioValue2 !== "Custom") {
      if (formValues.endDate < formValues.startDate) {
        errors.endDate = t("errors.endDateErrorMsg");
      }
    }
    if (
      formValues.radioValue === "Recurrent" &&
      formValues.radioValue2 !== "Custom"
    ) {
      if (formValues.endDate < formValues.startDate) {
        errors.endDate = t("errors.endDateErrorMsg");
      }
    }
    if (!formValues.startTime) {
      errors.startTime = t("errors.required");
    }
    if (
      formValues.radioValue2 !== "Custom" &&
      // isBefore(formValues.startDate, new Date())
      isBefore(formValues.startDate, moment().subtract(1, "days").toDate())
    ) {
      errors.startDate = t("errors.startDateErrorMsg");
    }
    if (!Object.keys(formValues.location).length) {
      errors.location = t("errors.required");
      addErrorToast(t("errors.locationRequiredErrorMsg"));
    }
    setFormErrors({ ...errors });

    if (Object.keys(errors).length > 0) {
      addErrorToast(t("errors.validationGeneralError"));
      return;
    }

    let toDays = [];
    let sDays = [];
    let sortedDates = [];
    let dateWithTime = "";
    let startDateTime =
      formValues.radioValue2 !== "Custom" &&
      moment(formValues.startDate.format("YYYY-MM-DD") + " " + formValues.startTime.format("HH:mm"), "YYYY-MM-DD HH:mm");
    // startDateTime = formValues.radioValue2 !== "Custom" && sub(startDateTime, { months: 1 });
    let endDateTime =
      formValues.radioValue !== "One Time" &&
      formValues.radioValue2 !== "Custom" &&
      moment(formValues.endDate.format("YYYY-MM-DD") + " " + formValues.startTime.format("HH:mm"), "YYYY-MM-DD HH:mm");
    if (
      formValues.radioValue === "Recurrent" &&
      formValues.radioValue2 === "Daily"
    ) {
      let current = startDateTime;
      while (current <= endDateTime) {
        toDays.push(current.toISOString());
        // current = addDays(current, 1);
        current = current.add(1, 'Days');
      }
    }
    if (
      formValues.radioValue === "Recurrent" &&
      formValues.radioValue2 === "Custom"
    ) {
      sortedDates = [...formValues.daysInWeek].sort((a, b) => {
        return new Date(a) - new Date(b);
      });
      sortedDates.map((date) =>
        toDays.push(
          set(date, {
            hours: Number(formValues.startTime.format("HH")),
            minutes: Number(formValues.startTime.format("mm")),
            seconds: 0,
          })
        )
      );
    }
    if (
      formValues.radioValue === "Recurrent" &&
      formValues.radioValue2 === "Weekly"
    ) {
      dateWithTime =
        moment(formValues.startDate.toDate()).format("YYYY/MM/DD") +
        "," +
        formValues.startTime.format("hh") +
        ":" +
        formValues.startTime.format("mm") +
        " " +
        formValues.startTime.format("a");
      startDateTime = moment(formValues.startDate.format("YYYY-MM-DD") + " " + formValues.startTime.format("HH:mm"), "YYYY-MM-DD HH:mm");
      endDateTime = moment(formValues.endDate.format("YYYY-MM-DD") + " " + formValues.startTime.format("HH:mm"), "YYYY-MM-DD HH:mm");
      sDays = [...formValues.daysInWeek].map((day) => getDay(day));
      sDays = sDays.sort((a, b) => a - b);
    }

    const body = {
      isPublished: false,
      eventId: classObj.id,
      eventName: classObj.eventName,
      startDate:
        formValues.radioValue === "Recurrent" &&
          formValues.radioValue2 === "Custom"
          ? toDays[0]
          : formValues.radioValue2 === "Weekly"
            ? moment(dateWithTime, "YYYY/MM/DD hh:mm a").toISOString()
            : formValues.startDate.format("YYYY-MM-DD"),
      timing: formValues.startTime.format("hh:mm a"),
      endAfter: "",
      meridiem: formValues.startTime.format("A"),
      ...(formValues.radioValue === "Recurrent"
        ? { recurrenceType: formValues.radioValue2.toLowerCase() }
        : {}),
      endBy:
        formValues.radioValue === "Recurrent" &&
          formValues.radioValue2 === "Daily"
          ? endDateTime
          : formValues.radioValue2 === "Weekly"
            ? endDateTime
            : formValues.radioValue2 === "Custom"
              ? toDays[toDays.length - 1]
              : startDateTime,
      utcOffset: new Date().getTimezoneOffset(),
      ...(formValues.radioValue2 === "Weekly"
        ? { daysInWeek: [], selectedDays: sDays }
        : {
          daysInWeek:
            formValues.radioValue === "Recurrent" ? toDays : [startDateTime.toDate()],
        }),
      eventStartDateTime:
        formValues.radioValue === "Recurrent" &&
          formValues.radioValue2 === "Custom"
          ? toDays[0]
          : startDateTime,
      location: {
        locationId: formValues.location._id,
        address: formValues.location.address,
        addressName: formValues.location.addressName,
        houseNumber: formValues.location.houseNumber,
        city: formValues.location.city,
        zip: formValues.location.zip ? formValues.location.zip : "",
      },
      eventStatus: "Published",
      startTime: formValues.startTime,
      endDate: formValues.endDate,
      endTime: formValues.endTime,
    };
    setFormScheduleValues(body);
    // commented because of merge tab in general
    // }
  };

  const handlePrevStep = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleRadioValueChange = (newValue) => {
    if (newValue === "Recurrent") {
      setFormValues((prevValues) => ({
        ...prevValues,
        radioValue2: "Daily",
      }));
    }
    setFormValues((prevValues) => ({
      ...prevValues,
      radioValue: newValue,
      radioValue2: "Daily",
    }));
  };

  const handleRadioValueChange2 = (newValue) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      radioValue2: newValue,
    }));
  };

  const handleStartDateChange = (date) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      startDate: date,
    }));
  };

  const handleEndDateChange = (date) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      endDate: date,
    }));
  };

  const handleStartTimeChange = (newTime) => {
    // var duration = moment.duration(moment(typeof formValues.endTime == "object" ? formValues.endTime : formValues.endTime.toDate()).diff(moment(newTime.toDate())));
    // var minutes = duration.minutes();

    // }
    // return false

    setFormValues((prevValues) => ({
      ...prevValues,
      startTime: newTime,
    }));
  };

  const handleEndTimeChange = (newEndTime) => {
    // var duration = moment.duration(moment(newEndTime.toDate()).diff(moment(typeof formValues.startTime == "object" ? formValues.startTime : formValues.startTime.toDate())));
    // var minutes = duration.minutes();

    // }
    // return false

    setFormValues((prevValues) => ({
      ...prevValues,
      endTime: newEndTime,
    }));
  };

  const handleLocationChange = (newLocation) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      location: newLocation,
    }));
  };

  const handleDaysInWeekChange = (date) => {
    let daysInWeekCopy = [...formValues.daysInWeek];
    if (dateInArray(date, daysInWeekCopy)) {
      daysInWeekCopy = daysInWeekCopy.filter((day) => !isSameDay(day, date));
      setFormValues((prevValues) => ({
        ...prevValues,
        daysInWeek: daysInWeekCopy,
      }));
    } else {
      daysInWeekCopy = [...daysInWeekCopy, date];
      setFormValues((prevValues) => ({
        ...prevValues,
        daysInWeek: daysInWeekCopy,
      }));
    }
  };

  const handleClearDaysInWeek = () => {
    setFormValues((prevValues) => ({
      ...prevValues,
      daysInWeek: [],
    }));
  };

  const handleCalendarDaysChange = (dates) => {
    const datesSelected = dates.map((date) => {
      let transformedDate;
      if (date instanceof DateObject) {
        transformedDate = date.toDate();
      }
      return transformedDate;
    });
    setFormValues((prevValues) => ({
      ...prevValues,
      daysInWeek: datesSelected,
    }));
  };

  const handleSubmit = async () => {

    setSubmitting(true);
    let toDays = [];
    let sDays = [];
    let sortedDates = [];
    let dateWithTime = "";
    let startDateTime =
      formValues.radioValue2 !== "Custom" &&
      moment(formValues.startDate.format("YYYY-MM-DD") + " " + formValues.startTime.format("HH:mm"), "YYYY-MM-DD HH:mm");
    // startDateTime = formValues.radioValue2 !== "Custom" && sub(startDateTime, { months: 1 });
    let endDateTime =
      formValues.radioValue !== "One Time" &&
      formValues.radioValue2 !== "Custom" &&
      moment(formValues.endDate.format("YYYY-MM-DD") + " " + formValues.startTime.format("HH:mm"), "YYYY-MM-DD HH:mm");
    if (
      formValues.radioValue === "Recurrent" &&
      formValues.radioValue2 === "Daily"
    ) {
      let current = startDateTime;
      while (current <= endDateTime) {
        toDays.push(current.toISOString());
        // current = addDays(current, 1);
        current = current.add(1, 'Days');
      }
    }
    if (
      formValues.radioValue === "Recurrent" &&
      formValues.radioValue2 === "Custom"
    ) {
      sortedDates = [...formValues.daysInWeek].sort((a, b) => {
        return new Date(a) - new Date(b);
      });
      sortedDates.map((date) =>
        toDays.push(
          set(date, {
            hours: Number(formValues.startTime.format("HH")),
            minutes: Number(formValues.startTime.format("mm")),
            seconds: 0,
          })
        )
      );
    }
    if (
      formValues.radioValue === "Recurrent" &&
      formValues.radioValue2 === "Weekly"
    ) {
      dateWithTime =
        moment(formValues.startDate.toDate()).format("YYYY/MM/DD") +
        "," +
        formValues.startTime.format("hh") +
        ":" +
        formValues.startTime.format("mm") +
        " " +
        formValues.startTime.format("a");
      startDateTime = moment(formValues.startDate.format("YYYY-MM-DD") + " " + formValues.startTime.format("HH:mm"), "YYYY-MM-DD HH:mm");
      endDateTime = moment(formValues.endDate.format("YYYY-MM-DD") + " " + formValues.startTime.format("HH:mm"), "YYYY-MM-DD HH:mm");
      sDays = [...formValues.daysInWeek].map((day) => getDay(day));
      sDays = sDays.sort((a, b) => a - b);
    }

    const body = {
      isPublished: true,
      eventId: classObj.id,
      eventName: classObj.eventName,
      startDate:
        formValues.radioValue === "Recurrent" &&
          formValues.radioValue2 === "Custom"
          ? toDays[0]
          : formValues.radioValue2 === "Weekly"
            ? moment(dateWithTime).toISOString()
            : formValues.startDate.format("YYYY-MM-DD"),
      timing: formValues.startTime.format("hh:mm a"),
      endAfter: "",
      meridiem: formValues.startTime.format("A"),
      ...(formValues.radioValue === "Recurrent"
        ? { recurrenceType: formValues.radioValue2.toLowerCase() }
        : {}),
      endBy:
        formValues.radioValue === "Recurrent" &&
          formValues.radioValue2 === "Daily"
          ? endDateTime
          : formValues.radioValue2 === "Weekly"
            ? endDateTime
            : formValues.radioValue2 === "Custom"
              ? toDays[toDays.length - 1]
              : startDateTime,
      utcOffset: new Date().getTimezoneOffset(),
      ...(formValues.radioValue2 === "Weekly"
        ? { daysInWeek: [], selectedDays: sDays }
        : {
          daysInWeek:
            formValues.radioValue === "Recurrent" ? toDays : [startDateTime.toDate()],
        }),
      eventStartDateTime:
        formValues.radioValue === "Recurrent" &&
          formValues.radioValue2 === "Custom"
          ? toDays[0]
          : startDateTime,
      location: {
        locationId: formValues.location._id,
        address: formValues.location.address,
        addressName: formValues.location.addressName,
        houseNumber: formValues.location.houseNumber,
        city: formValues.location.city,
        zip: formValues.location.zip ? formValues.location.zip : "",
        location: formValues.location.location,
      },
    };

    const config = {
      method: "post",
      // url: `${getUrlForEvent()}schools/scheduleTheClass`,
      url: `${getUrlForEvent()}schedule/create`,
      data: body,
    };
    dispatch(setActionLoading(true));
    const request = await axiosInstance(config);
    dispatch(setActionLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode !== 200) {
        addErrorToast(request.data.message)
        setActiveStep(0);
      } else {
        addSuccessToast(t("successes.success"));
        dispatch(
          dashboardActions.setUpdateSessionComp(
            dashboardReduxState.updateSessionComp + 1
          )
        );
        setOpenSuccessModal(true);
      }
    }
    setSubmitting(false);
  };

  const clearFormValues = () => {
    setFormValues({
      radioValue: "One Time",
      radioValue2: "",
      startDate: new Date(),
      endDate: "",
      startTime: "",
      location: {},
      daysInWeek: [],
    });
  };

  return (
    <>
      <div className={`w-full [max-w-lg] flex flex-col gap-2 ${isFromDetail === false ? "py-0 px-0 sm:px-0" : "px-0"}`}>
        {!edit ? <div>
          <AddScheduleStep1
            handleRadioValueChange={handleRadioValueChange}
            handleRadioValueChange2={handleRadioValueChange2}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            handleStartTimeChange={handleStartTimeChange}
            handleEndTimeChange={handleEndTimeChange}
            eventFormValues={eventFormValues}
            setEventFormValues={setEventFormValues}
            formValues={formValues}
            setFormValues={setFormValues}
            formErrors={formErrors}
            sessionTimings={displayDuration}
            handleLocationChange={handleLocationChange}
            handleDaysInWeekChange={handleDaysInWeekChange}
            handleClearDaysInWeek={handleClearDaysInWeek}
            handleCalendarDaysChange={handleCalendarDaysChange}
            handleNextStep={handleNextStep}
            disabledButton={isSubmitting}
            clearFormValues={clearFormValues}
          />
          {/* <div className={"flex gap-2 justify-center pt-5 w-full sm:w-3/5"}>
            <TwButton
              variant={"secondary-outline"}
              className={"w-full sm:w-1/3"}
              onClick={() => {
                setTabCurrentState("4");
              }}
            >
              {t("inputFieldsTitle.back")}
            </TwButton>
            <TwButton
              variant={"secondary"}
              className={"w-full sm:w-1/3"}
              actionLoading={(loadingReduxState.actionLoading)}
              onClick={(e) => {
                handleNextStep();
                // setTabCurrentState("6");
              }}
            >
              {t("inputFieldsTitle.continue")}
            </TwButton>
          </div> */}
        </div>
          : <div>
            <EditSchedules
              edit={true}
              duration={formValues.duration}
              classObj={formValues}
              eventFormValues={eventFormValues}
              setEventFormValues={setEventFormValues}
              // setLoading={setLoading}
              formScheduleValues={formScheduleValues}
              setFormScheduleValues={setFormScheduleValues}
              reloadScheduleDetails={reloadScheduleDetails}

              handleRadioValueChange={handleRadioValueChange}
              handleRadioValueChange2={handleRadioValueChange2}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
              handleStartTimeChange={handleStartTimeChange}
              handleLocationChange={handleLocationChange}
              handleDaysInWeekChange={handleDaysInWeekChange}
              handleClearDaysInWeek={handleClearDaysInWeek}
              handleCalendarDaysChange={handleCalendarDaysChange}
              formValues={formValues}
              formErrors={formErrors}
              handleSubmit={handleNextStep}
              clearFormValues={clearFormValues}
              isFromDetail={isFromDetail}
            />
          </div>}
      </div>
      <SuccessScheduleModal
        open={openSuccessModal}
        handleAddNew={() => {
          clearFormValues();
          setActiveStep(0);
          setOpenSuccessModal(false);
        }}
        handleClose={() => {
          setOpenSuccessModal(false);
          dispatch(dashboardActions.setCalendarSessionId(-1));
          dispatch(dashboardActions.setCalendarOpen(false));
          navigate("/home/dashboard");
        }}
        bookingLink={shareLink}
      />
    </>
  );
}
